<template>
  <div id="app">
    <!-- Logo -->
    <div class="columns is-mobile">
      <div class="column is-three-fifths is-offset-one-fifth">
        <figure class="image is-square" ref="logo">
          <img alt="XBOX Game Pass" src="./assets/logo.png" />
        </figure>
      </div>
    </div>
    <!-- Loading -->
    <b-loading :is-full-page="true" :active.sync="loading"></b-loading>
    <!-- Content -->
    <div v-if="alreadyClaimed">
      <h1 class="title has-text-centered">Vous avez déjà réclamé un pass !</h1>
    </div>
    <div v-else>
      <div class="container" v-if="!loading">
        <div class="container" v-if="passes > 0">
          <div v-if="!submitted">
            <h1 class="title has-text-centered is-spaced">
              Vous venez de remporter 1 mois de
              <span class="xbox-color">Game Pass Ultimate</span>
            </h1>
            <h2 class="subtitle has-text-centered">
              Pour recevoir le code d'activation, merci de renseigner votre
              adresse email dans le formulaire ci-dessous :
            </h2>
            <div>
              <b-field>
                <b-input
                  placeholder="Votre adresse email"
                  type="email"
                  size="is-medium"
                  icon="mdi mdi-email-outline"
                  v-model="email"
                  :disabled="processing"
                  validation-message="Adresse email non valide"
                ></b-input>
              </b-field>

              <b-button
                type="is-primary"
                size="is-medium"
                icon-right="mdi mdi-xbox"
                :loading="processing"
                @click="submit"
                expanded
                >Récupérer mon Game Pass</b-button
              >
            </div>
          </div>
          <div class="container" v-else>
            <h1 class="title has-text-centered is-spaced" ref="title">
              Merci de faire un screenshot de votre code unique :
            </h1>
            <div class="has-text-centered">
              <p class="game-pass">{{ pass.code }}</p>
              <div class="gray-bloc">
                Pour l’activer, connectez-vous à votre Xbox One avec votre
                compte Microsoft et entrez le code à 25 caractères dans l’onglet
                store ou depuis votre ordinateur sur microsoft.com/redeem.
              </div>
              <div class="gray-bloc">
                Ce code est activable jusqu’au 20 juin 2020
              </div>
              <div class="gray-bloc">
                Apprenez en plus sur ce que vous venez de remporter en appuyant
                sur le
                <em>bouton B</em> du mobilier
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <h1 class="title has-text-centered is-spaced">Bien joué !</h1>
          <h2 class="subtitle has-text-centered">
            Malheureuseument, il n'y a plus de Game Pass Ultimate a remporter
          </h2>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <div class="terms">
      Maximum de 36 mois d'Ultimate cumulables par compte. Les titres et le
      nombre de jeux varient dans le temps et selon les pays. Si votre
      abonnement prend fin ou si un jeu est supprimé, vous devez réactiver votre
      abonnement ou acheter le jeu pour continuer à utiliser les add-on ou les
      articles acquis pour ce jeu. Un abonnement Xbox Live Gold (vendu
      séparément) est requis pour certains jeux et pour le mode multijoueur en
      ligne sur Xbox One. Frais FAI et restrictions d'âge applicables. Certaines
      conditions, limitations et exclusions s'appliquent aux offres
      promotionnelles. Le service, certaines fonctionnalités et certaines
      exigences peuvent être modifiés ou retirés. Soumis au Contrat de Services
      Microsoft (microsoft.com/msa). Sauf obligation légale, le code n'est ni
      échangeable ni remboursable. Les images sont représentatives des jeux du
      catalogue. xbox.com/game-pass.©/™/®2019 Microsoft.
    </div>
  </div>
</template>

<script>
import { gsap, Elastic } from 'gsap';

import axios from 'axios';

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export default {
  name: 'app',
  data() {
    return {
      alreadyClaimed: false,
      passes: null,
      pass: {},
      loading: true,
      submitted: false,
      processing: false,
      email: ''
    };
  },
  methods: {
    submit() {
      if (validateEmail(this.email)) {
        this.processing = true;
        axios
          .post(`${process.env.VUE_APP_SERVER_API}passes/claim`, {
            email: this.email
          })
          .then(response => {
            this.pass = response.data;
            this.submitted = true;
            localStorage.claimed = true;
            return response;
          })
          .catch(err => {
            this.$buefy.toast.open({
              duration: 5000,
              message: err.response.data.message,
              position: 'is-bottom',
              type: 'is-danger',
              queue: false
            });
          })
          .finally(() => {
            this.processing = false;
          });
      } else {
        this.$buefy.toast.open({
          duration: 5000,
          message: 'Veuillez vérifier votre adresse email',
          position: 'is-bottom',
          type: 'is-danger'
        });
      }
    }
  },
  mounted() {
    const { logo } = this.$refs;

    if (localStorage.claimed) {
      this.alreadyClaimed = true;
    }

    gsap.from(logo, {
      duration: 1,
      scale: 0.9,
      ease: Elastic.easeOut,
      yoyo: true,
      repeat: -1
    });

    axios
      .get(`${process.env.VUE_APP_SERVER_API}passes/available`)
      .then(response => {
        this.passes = response.data;
      })
      .catch(err => {
        this.passes = `ERR: ${err}`;
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style lang="scss"></style>
